import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react';

import useLocalization from 'hooks/useLocalization';
import { clearAppMeBootstrap } from 'utils/auth/loadAppUserProfile';

/**
 * באנר "מצב תמיכה" — מוצג לכל אורך האפליקציה כאשר ה-session נושא claim של act
 * (כלומר עובד פאנר מחובר כלקוח דרך ה-ops console). כפתור היציאה עושה signOut
 * ומחזיר למסך הכניסה, שם העובד מתחבר מחדש לחשבון שלו (אפשרות 1 — session מוחלף).
 */
export default function ImpersonationBanner() {
  const { actor, signOut, isLoaded } = useClerkAuth();
  const { user } = useUser();
  const { currentLocale } = useLocalization();
  const t = currentLocale.opsConsole.impersonationBanner;
  const [leaving, setLeaving] = useState(false);

  // actor קיים רק כאשר ה-session הוא התחזות (Clerk מזריק את claim ה-act).
  if (!isLoaded || !actor) return null;

  const asName = user?.primaryEmailAddress?.emailAddress || user?.fullName || '';

  const handleExit = async () => {
    setLeaving(true);
    // ניקוי מצב חברת הלקוח לפני היציאה — אחרת אחרי ההתחברות מחדש לחשבון שלך
    // רשימת השיחות נטענת עם X-Company-Id של הלקוח (מ-localStorage) עד ש-/me
    // מעדכן לחברה שלך. מקביל לניקוי שה-logout הרגיל של האפליקציה עושה.
    localStorage.removeItem('companyId');
    localStorage.removeItem('whatsapp-token');
    clearAppMeBootstrap();
    await signOut({ redirectUrl: '/login' });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        maxWidth: '100%',
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
      }}
    >
      <SupportAgentIcon sx={{ fontSize: 20 }} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {t.label.replace('{account}', asName)}
      </Typography>
      <Box sx={{ flex: 1 }} />
      <Button
        size="small"
        variant="contained"
        color="inherit"
        startIcon={<LogoutIcon />}
        onClick={handleExit}
        disabled={leaving}
        sx={{ color: 'warning.main', bgcolor: 'background.paper', '&:hover': { bgcolor: 'grey.100' } }}
      >
        {t.exit}
      </Button>
    </Box>
  );
}
